/* ===========================================================================
   HEYBABE Atelier — components.js
   Presentation behaviour: sliders, disclosures, accordions.

   Kept out of commerce.js on purpose. A carousel is not a purchase path, and a
   bug in one must never be able to affect the other. Also kept out of
   motion/*.js, which is optional enhancement and may not load at all.
   =========================================================================== */

(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------------------
     Hero slider
     Native behaviour: no transform library, no horizontal track, no vendor
     height injection. Slides stack in normal flow and one is shown at a time,
     so the section is the natural height of the tallest slide and nothing has
     to fight a track height.
     --------------------------------------------------------------------- */
  function initHero(root) {
    var slides = $$('[data-hb-hero-slide]', root);
    if (slides.length < 2) return;

    var dots = $$('[data-hb-hero-dot]', root);
    var index = 0;
    var timer = null;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var wantsAuto = root.getAttribute('data-autoplay') === 'true';

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (s, i) {
        var on = i === index;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach(function (d, i) {
        var on = i === index;
        d.classList.toggle('is-active', on);
        d.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      if (!wantsAuto || reduceMotion) return;
      stop();
      timer = setInterval(function () { show(index + 1); }, interval);
    }

    root.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-hb-hero-dot]');
      if (!dot) return;
      stop();
      show(parseInt(dot.getAttribute('data-hb-hero-dot'), 10));
      start();
    });

    /* Pause on hover and when the tab is hidden. A rotating hero the visitor
       cannot read is worse than a static one. */
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    /* Touch swipe. Only horizontal intent cancels the scroll. */
    var startX = 0, startY = 0, tracking = false;
    root.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      tracking = true;
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX;
      var dy = t.clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      stop();
      show(index + (dx < 0 ? 1 : -1));
      start();
    }, { passive: true });

    start();
  }

  /* ---------------------------------------------------------------------
     Accordions — height without a fixed pixel value
     --------------------------------------------------------------------- */
  function initDisclosures(scope) {
    $$('details[data-hb-accordion]', scope).forEach(function (el) {
      var summary = el.querySelector('summary');
      var panel = el.querySelector('.hb-accordion__panel');
      if (!summary || !panel) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var opening = !el.open;
        var parent = el.parentElement;
        if (opening && parent) {
          $$('[data-hb-accordion]', parent).forEach(function (other) {
            if (other !== el && other.open) { other.open = false; other.dispatchEvent(new Event('hb-toggle')); }
          });
        }
        el.open = opening;
        el.dispatchEvent(new Event('hb-toggle'));
      });
    });
  }

  function boot() {
    $$('[data-hb-hero]').forEach(initHero);
    initDisclosures(document);
  }

  document.addEventListener('shopify:section:load', function () { boot(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ---------------------------------------------------------------------------
   Newsletter card
   Non-modal on purpose: no showModal, no inert, no scroll lock, so the
   hamburger, cart and the page stay usable. Opens only after real
   engagement (25s, or 8s plus half the page scrolled), never over an
   open drawer, and is remembered for 14 days. Storage is best-effort.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  var KEY = 'hb_newsletter_dismissed';
  var HOLD_DAYS = 14;
  var memory = false;

  function dismissed() {
    if (memory) return true;
    try {
      var at = parseInt(window.localStorage.getItem(KEY), 10);
      return !!at && Date.now() - at < HOLD_DAYS * 864e5;
    } catch (e) { return false; }
  }

  function remember() {
    memory = true;
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* private mode */ }
  }

  function initNewsletterPopup() {
    var popup = document.getElementById('NewsletterPopup');
    if (!popup || typeof popup.show !== 'function') return;

    var posted = popup.querySelector('.hb-alert--success');
    var failed = popup.querySelector('.hb-alert--error');

    function open() {
      if (popup.open) return;
      /* show() runs the dialog focusing steps; hand focus straight back so
         the card never steals it from whatever the visitor is doing. */
      var prev = document.activeElement;
      popup.show();
      if (prev && prev !== document.body && prev.focus) prev.focus({ preventScroll: true });
      else if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    }

    popup.addEventListener('click', function (e) {
      if (e.target.closest('[data-hb-dialog-close]')) {
        remember();
        popup.close();
      }
    });
    popup.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { remember(); popup.close(); }
    });
    popup.addEventListener('close', remember);
    var form = popup.querySelector('form');
    if (form) form.addEventListener('submit', remember);

    if (failed) { open(); failed.focus(); return; }
    if (posted) {
      remember();
      open();
      window.setTimeout(function () { if (popup.open) popup.close(); }, 6000);
      return;
    }
    if (dismissed()) return;

    var start = Date.now();
    var armed = true;

    /* Bottom-edge order: cookie notice, then the sticky purchase bar, then this
       card. It waits for the notice, never interrupts typing, stays out of the
       cart page, and sits above the purchase bar on a product page. */
    if (document.body.classList.contains('template-cart')) return;

    function drawerBusy() {
      if (document.querySelector('dialog[open]:not(#NewsletterPopup)')) return true;
      var cookie = document.querySelector('[data-hb-cookie]');
      if (cookie && !cookie.hidden) return true;
      var el = document.activeElement;
      return !!(el && /^(INPUT|TEXTAREA|SELECT)$/.test(el.nodeName));
    }
    function tryOpen() {
      if (!armed) return;
      if (drawerBusy()) { window.setTimeout(tryOpen, 5000); return; }
      var stickyBar = document.querySelector('[data-hb-sticky-bar]');
      popup.style.setProperty('--hb-bottom-offset', (stickyBar ? stickyBar.offsetHeight : 0) + 'px');
      armed = false;
      window.removeEventListener('scroll', onScroll);
      open();
    }
    function onScroll() {
      if (!armed || Date.now() - start < 8000) return;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h >= 0.5) tryOpen();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.setTimeout(tryOpen, 25000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initNewsletterPopup);
  else initNewsletterPopup();
})();

/* ---------------------------------------------------------------------------
   Kombin: the knot fills when the partner piece is really in the cart.
   Reads the cart that commerce.js publishes; never calls a cart endpoint.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  document.addEventListener('hb:cart:updated', function (e) {
    var cart = e.detail && e.detail.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    var pairs = document.querySelectorAll('[data-hb-kombin-pair]');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      var partnerId = pair.getAttribute('data-partner-id');
      var has = cart.items.some(function (item) { return String(item.product_id) === partnerId; });
      var had = pair.classList.contains('is-complete');
      pair.classList.toggle('is-complete', has);
      if (has && !had) {
        pair.classList.add('is-tying');
        (function (el) {
          window.setTimeout(function () { el.classList.remove('is-tying'); }, 700);
        })(pair);
      }
    }
  });
})();

/* ---------------------------------------------------------------------------
   Card swatches, fine pointers only: hovering a colour previews that variant's
   real photograph in the card. Links and click behaviour are untouched; touch
   devices are not affected.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function restore(card) {
    var img = card.querySelector('.hb-card__img--first');
    if (!img || !img.hasAttribute('data-hb-src')) return;
    img.src = img.getAttribute('data-hb-src');
    if (img.hasAttribute('data-hb-srcset')) img.setAttribute('srcset', img.getAttribute('data-hb-srcset'));
    img.removeAttribute('data-hb-src');
    img.removeAttribute('data-hb-srcset');
    card.classList.remove('is-previewing');
  }

  document.addEventListener('mouseover', function (e) {
    var link = e.target.closest && e.target.closest('[data-hb-swatch-src]');
    if (!link) return;
    var card = link.closest('[data-hb-card]');
    var img = card && card.querySelector('.hb-card__img--first');
    if (!img) return;
    if (!img.hasAttribute('data-hb-src')) {
      img.setAttribute('data-hb-src', img.currentSrc || img.src);
      if (img.hasAttribute('srcset')) img.setAttribute('data-hb-srcset', img.getAttribute('srcset'));
    }
    img.removeAttribute('srcset');
    img.src = link.getAttribute('data-hb-swatch-src');
    card.classList.add('is-previewing');
  });

  document.addEventListener('mouseout', function (e) {
    var list = e.target.closest && e.target.closest('.hb-card__swatches');
    if (!list || (e.relatedTarget && list.contains(e.relatedTarget))) return;
    var card = list.closest('[data-hb-card]');
    if (card) restore(card);
  });
})();

